/**
 * Survey types
 */
export var SurveyType;
(function (SurveyType) {
    SurveyType["ONBOARDING"] = "onboarding";
    SurveyType["CHECKIN"] = "checkin";
    SurveyType["FEEDBACK"] = "feedback";
})(SurveyType || (SurveyType = {}));
/**
 * Question types
 */
export var QuestionType;
(function (QuestionType) {
    QuestionType["SINGLE_CHOICE"] = "single_choice";
    QuestionType["MULTI_CHOICE"] = "multi_choice";
    QuestionType["TEXT"] = "text";
    QuestionType["NUMBER"] = "number";
    QuestionType["DATE"] = "date";
})(QuestionType || (QuestionType = {}));
/**
 * Survey screen types
 */
export var ScreenType;
(function (ScreenType) {
    ScreenType["INTRO"] = "INTRO";
    ScreenType["QUESTION"] = "QUESTION";
})(ScreenType || (ScreenType = {}));
/**
 * Survey response status
 */
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["IN_PROGRESS"] = "in_progress";
    ResponseStatus["COMPLETED"] = "completed";
    ResponseStatus["ABANDONED"] = "abandoned";
})(ResponseStatus || (ResponseStatus = {}));
